<template>
    <!-- Services section start -->
	<section id="services-section" class="px-4  lg:px-32 py-16 relative overflow-hidden margin-offset-fix">
        <div class="max-w-7xl mx-auto">
            <!-- Text wrapper start -->
            <div class="gap-8 flex-col md:flex-row">
                <!-- Loading state -->
                <template v-if="isLoading">
                    <LoadingSkeleton size="xl" class="mb-4"/>
                    <LoadingSkeleton size="md" class="w-1/2"/>
                </template>
                
                <!-- Content state -->
                <template v-else>
                    <!-- Main text start -->
                    <h1 class="uppercase text-3xl md:text-5xl text-orange mb-4 font-semibold ">
                        {{ locations.title }}
                    </h1>
                    <p class="capitalize xl:w-1/2 text-orange mb-8">
                        {{ extractText(locations.locations) }}
                    </p>
                    <!-- Main text end -->
                </template>
            </div>
            <!-- Text wrapper end -->

            <!-- Circle start -->
            <!-- <div class="bg-pink h-64 w-64 rounded-full absolute top-0 -right-20 mt-16 -z-20"></div> -->
            <!-- Circle end -->
        </div>
	</section>
	<!-- Services section end -->
</template>

<script>
import { contentfulClient } from '@/config/contentful'
import LoadingSkeleton from '@/components/LoadingSkeleton.vue'

export default {
    name: 'ServiceSection',
    components: {
        LoadingSkeleton
    },
    data() {
        return {
            isLoading: true,
            locations: {
                title: '',
                locations: ''
            }
        }
    },
    methods: {
        extractText(richText) {
            if (!richText || !richText.content) return ''
            return richText.content
                .map(item => item.content?.map(subItem => subItem.value).join(''))
                .join('\n')
                .trim()
        }
    },
    async created() {
        try {
            const response = await contentfulClient.getEntries({
                content_type: 'locations',
                limit: 1
            })
            
            if (response.items && response.items.length > 0 && response.items[0].fields) {
                this.locations = response.items[0].fields
            }
        } catch (error) {
            console.error('Error fetching locations content:', error)
        } finally {
            this.isLoading = false
        }
    }
}
</script>

<style>

</style>